import React, { useEffect, useState } from "react";
import { getNews } from "../Service/Api";
import { Link } from 'react-router-dom'; 
import LazyLoad from "react-lazyload";

const News = () => { 
  const [circularData, setCircularData] = useState([]); 
  const [openModel, setOpenmodal] = useState(false); 
  const [selectedItem, setSelectedItem] = useState(null); 
  useEffect(() => {
    const fetchData = async () => {
      try {
        
        const cirData1 = await getNews();
         const cirData = cirData1.filter((item) =>  item.category === "News" ); 
          cirData.sort((a,b) => new Date(b.fromDate) - new Date(a.fromDate)); 
        setCircularData(cirData || []);
      } catch (error) {
        console.error("Failed to fetch news:", error); 
        setCircularData([]);
      }
    };
    fetchData();
  }, []);
  const modalPopup = (item) => {
    setSelectedItem(item); // Set the clicked item's data
    setOpenmodal(true); // Open the modal
};

const handleClose = () => {
    setOpenmodal(false);
    setSelectedItem(null); // Clear the selected item
};
  const emptyArray = [
      { },
  ];
 
  return (
    <>
    <div className="newsbg">
    <div className='mainstitle'>  
        <h2> Circulars </h2> 
    <Link to="/News"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/arrow.png" className="img-fluid"/></Link> 
    </div>
    <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up" onMouseOut={(event) => event.currentTarget.start()}>
      <ul className="newsboxlist"> 
        {(circularData.length > 0 ? circularData : emptyArray).map((item, index) => (   
          <li key={index}>
             <div className="newsbox">
               <div className="newsdesc"> 
               <p onClick={() => modalPopup(item)}> {item.title}</p>
               </div>
               {item.attachments && item.attachments[0] && ( 
                 <Link to={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank"><i className="bi bi-paperclip"></i></Link> 
               )}  
             </div>
           </li>
           ))
         }
      </ul>
    </marquee>
  </div>
  {openModel && selectedItem && (
    <div className="eventPopup">
      <div className="eventpopupbody">
        <div className="eventpopupcontent">
          <button onClick={handleClose} className="closebtn">X</button>
          <div className="schooleventbox">
          <div className="schooleventrightbox">
          <h5><div dangerouslySetInnerHTML={{ __html: selectedItem.title }} /> </h5>
              <p> <div dangerouslySetInnerHTML={{ __html: selectedItem.description }} /></p>
              {selectedItem.attachments && selectedItem.attachments[0] && ( 
                <div className="attachment popupattch">
                <Link to={`https://webapi.entab.info/api/image/${selectedItem?.attachments}`} target="_blank"> Click Here To View</Link>
            </div>
              )} 
          </div>
          {selectedItem.images && selectedItem.images.length > 0  && selectedItem.images.length === 1 ? (
            selectedItem.images.map((image, index) => (
              <div key={index} className="schooleventleftbox galleryCount sub-gallerycount">
                <LazyLoad>
                  <a
                    data-magnify="gallery"
                    data-src={`https://webapi.entab.info/api/image/${image}`} // Using image source for gallery
                    data-group="a"
                    href={`https://webapi.entab.info/api/image/${image}`}
                  >
                    <img
                      src={`https://webapi.entab.info/api/image/${image}`}
                      className="img-fluid float-start"
                      alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                    />
                  </a>
                </LazyLoad>
              </div>
            ))
          ) : null}
          {selectedItem.images && selectedItem.images.length > 0  && selectedItem.images.length > 1 ? (
            selectedItem.images.map((image, index) => (
              <div key={index} className="schooleventleftbox galleryCount sub-gallerycount  multi-img">
                <LazyLoad>
                  <a
                    data-magnify="gallery"
                    data-src={`https://webapi.entab.info/api/image/${image}`} // Using image source for gallery
                    data-group="a"
                    href={`https://webapi.entab.info/api/image/${image}`}
                  >
                    <img
                      src={`https://webapi.entab.info/api/image/${image}`}
                      className="img-fluid"
                      alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                    />
                  </a>
                </LazyLoad>
              </div>
            ))
          ) : null}
           
          </div>
          
           <div className="row">
           {selectedItem.galleryAttachments?.length > 0 && (
                selectedItem.galleryAttachments.map((item,index) => (
                  <div
                  key={index}
                  className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"
                >
                  <LazyLoad>
                  <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${item}`}><img src={`https://webapi.entab.info/api/image/${item}`} className=" img-fluid" alt="The Air Force School Subroto Park" /></a>
                    </LazyLoad>
                </div> 
                ))
      )}
           </div>
        </div>
      </div>
    </div>
  )}
    </>
  );
};

export default News;
